import { useEffect, useRef } from "react";

interface useInfiniteScrollProps {
    hasMore: boolean;
    onIntersect: () => void;
    sentinelRef: React.RefObject<HTMLDivElement> | null;
}

const useInfiniteScroll = ({ sentinelRef, hasMore, onIntersect }: useInfiniteScrollProps) => {
    const hasMoreRef = useRef(hasMore);
    hasMoreRef.current = hasMore;
    const onIntersectRef = useRef(onIntersect);
    onIntersectRef.current = onIntersect;

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5
        };

        const observer = new IntersectionObserver(entries => {
            const [entry] = entries;
            if (entry.isIntersecting && hasMoreRef.current) {
                onIntersectRef.current();
            }
        }, options);

        const sentinelRefCurrent = sentinelRef?.current;

        if (sentinelRefCurrent) {
            observer.observe(sentinelRefCurrent);
        }

        return () => {
            if (sentinelRefCurrent) {
                observer.unobserve(sentinelRefCurrent);
            }
        };
    }, [hasMore]);
};

export default useInfiniteScroll;
